import { Component, input, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { InsuranceClaimService } from '../../../../shared/store/insurance-claim/insurance-claim.service';
import { InsuranceClaimRejectReasonModel } from '../../../../shared/store/insurance-claim/types';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { FormService } from '../../../../shared/store/form/form.service';
import { setValidators } from '../../../../shared/helper/formhelper';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.InsuranceClaimRejectReason)
@Component({
  selector: 'app-insurance-claim-reject-reason-content',
  templateUrl: './insurance-claim-reject-reason-content.component.html',
  styleUrls: ['./insurance-claim-reject-reason-content.component.scss'],
  standalone: false,
})
export class InsuranceClaimRejectReasonContentComponent implements OnInit {
  @Input() modalRandomIdentifier: number;
  @Input() insuranceClaimId: number;
  @Input() source: SourceEnum = SourceEnum.Component;
  rejectReasonMaxLength = input<number>();

  insuranceClaimRejectReasonForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly activeModalService: NgbActiveModal,
    private readonly subHeaderService: SubHeaderService,
    private readonly formService: FormService,
  ) {}

  ngOnInit(): void {
    this.insuranceClaimRejectReasonForm = this.formBuilder.group({
      rejectReason: ['', [Validators.required]],
    });

    const rejectReasonMaxLength = this.rejectReasonMaxLength();
    if (rejectReasonMaxLength && rejectReasonMaxLength > 0) {
      setValidators(
        this.insuranceClaimRejectReasonForm.get('rejectReason'),
        Validators.maxLength(rejectReasonMaxLength),
      );
    }

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'insuranceClaimRejectReason') this.onSubmit();

        this.subHeaderService.setTriggerAction('');
      });
  }

  onSubmit() {
    if (this.insuranceClaimRejectReasonForm.invalid) {
      this.insuranceClaimRejectReasonForm.markAllAsTouched();
      this.formService.countErrors(this.insuranceClaimRejectReasonForm, true);
      return;
    }

    const insuranceClaimRejectReasonModel: InsuranceClaimRejectReasonModel = {
      insuranceClaimId: this.insuranceClaimId,
      rejectReason:
        this.insuranceClaimRejectReasonForm.get('rejectReason')?.value,
    };

    this.insuranceClaimService.reject.call(insuranceClaimRejectReasonModel);

    this.activeModalService.close();
  }
}
